import { FunctionComponent, useEffect, useState } from 'react';
import { FlexContainer, LoadingContainer } from '@starjack/shared-components';
import { Dropzone } from '@/components/Dropzone/Dropzone';
import { ACCEPTED_FILES_IMAGE } from '@/constants/index';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(3),
    },
    dropZone: {
        width: '100%',
        height: '100%',
    },
}));

type LogoDropZoneProps = {
    onLogoChange: (nextLogo: File) => void;
    logo?: File;
    isLoading?: boolean;
};

export const LogoDropZone: FunctionComponent<
    React.PropsWithChildren<LogoDropZoneProps>
> = ({ logo, onLogoChange, isLoading }) => {
    const classes = useStyles();
    const [image, setImage] = useState('');

    useEffect(() => {
        setImage(logo ? URL.createObjectURL(logo) : '');
    }, [logo]);
    return (
        <>
            {isLoading ? (
                <LoadingContainer />
            ) : (
                <>
                    {image ? (
                        <FlexContainer
                            className={classes.dropZone}
                            style={{
                                backgroundImage: `url("${image}")`,
                                backgroundPosition: 'center center',
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                            }}
                        />
                    ) : (
                        <FlexContainer className={classes.dropZone}>
                            <Dropzone
                                accept={ACCEPTED_FILES_IMAGE}
                                onDrop={async (acceptedFiles) => {
                                    const [file] = acceptedFiles;

                                    if (file) {
                                        setImage(URL.createObjectURL(file));

                                        onLogoChange(file);
                                    }
                                }}
                            />
                        </FlexContainer>
                    )}
                </>
            )}
        </>
    );
};
